import { default as domainHourGroup } from './group/services'
import { default as domainHour } from './hour/services'
import { default as domainScheduleByDate } from './schedule-by-date/services'
import { default as domainSchedule } from './schedule/services'
import { default as domainTodayLookup } from './today-lookup/services'

export default {
	domainHourGroup,
	domainHour,
	domainScheduleByDate,
	domainSchedule,
	domainTodayLookup
}
